var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg051Minimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.132,477.792L383.034,354.693h78.869c11.068,0,20.039-8.971,20.039-20.039s-8.972-20.039-20.039-20.039h-87.17 c-33.149,0-60.117,26.969-60.117,60.117v86.168c0,11.068,8.971,20.039,20.039,20.039s20.039-8.972,20.039-20.039v-77.867 l123.097,123.097c3.914,3.913,9.043,5.869,14.171,5.869c5.128,0,10.257-1.957,14.171-5.869 C513.957,498.305,513.957,485.617,506.132,477.792z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.269,314.615h-87.17c-11.068,0-20.039,8.971-20.039,20.039s8.971,20.039,20.039,20.039h78.869L5.869,477.792 c-7.825,7.826-7.825,20.514,0,28.339c3.914,3.913,9.043,5.869,14.171,5.869c5.128,0,10.257-1.957,14.171-5.869l123.097-123.097 v77.867c0,11.068,8.971,20.039,20.039,20.039s20.039-8.972,20.039-20.039v-86.168 C197.386,341.584,170.417,314.615,137.269,314.615z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.132,5.87c-7.826-7.826-20.515-7.826-28.34,0L354.693,128.968V51.1c0-11.068-8.971-20.039-20.039-20.039 s-20.039,8.971-20.039,20.039v86.168c0,33.149,26.969,60.117,60.117,60.117h87.17c11.068,0,20.039-8.971,20.039-20.039 s-8.972-20.039-20.039-20.039h-78.869L506.132,34.209C513.957,26.383,513.957,13.695,506.132,5.87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.347,30.059c-11.068,0-20.039,8.971-20.039,20.039v78.869L34.21,5.87c-7.826-7.826-20.515-7.826-28.34,0 c-7.825,7.826-7.825,20.514,0,28.339l123.097,123.098H50.098c-11.068,0-20.039,8.971-20.039,20.039s8.971,20.039,20.039,20.039 h87.17c33.149,0,60.117-26.969,60.117-60.117v-87.17C197.386,39.031,188.415,30.059,177.347,30.059z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg051Minimize);
export default __webpack_public_path__ + "static/media/051-minimize.d0913f17f65df50cc549db7ee12f249a.svg";
export { ForwardRef as ReactComponent };